import React from 'react';
import { NavigationProps } from '@/types/navigation';
import { Progress } from '@/components/ui/progress';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// Replicate budget items here for display (ideally fetch or pass as props)
const budgetItems = [
  { title: "Needs", icon: "🏠", url: "/budgets/overview", spent: 750, limit: 1000 },
  { title: "Wants", icon: "🛍️", url: "/budgets/wants", spent: 300, limit: 500 },
  { title: "Travel", icon: "✈️", url: "/budgets/travel", spent: 1200, limit: 1500 },
  { title: "Lovely Mustang 69", icon: "🚗", url: "/budgets/mustang", spent: 50, limit: 500 },
  { title: "Savings", icon: "💰", url: "/budgets/savings", spent: 1000, limit: 1000 },
];

const BudgetsPage: React.FC<NavigationProps> = ({ onNavigate }) => {
  return (
    <div className="p-4 md:p-6">
      <h1 className="text-2xl font-bold mb-6">Budgets Overview</h1>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {budgetItems.map((budget) => {
          const percentageSpent = budget.limit > 0 ? (budget.spent / budget.limit) * 100 : 0;
          const remaining = budget.limit - budget.spent;
          const isOverspent = budget.spent > budget.limit;

          return (
            <Card 
              key={budget.title} 
              className="hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => { /* Handle navigation to specific budget detail page if needed */ 
                // Example: Extract page name from URL
                const pageName = budget.url.split('/').pop();
                // Check if pageName is a valid AppPage before navigating
                // For now, just log or navigate to a generic detail page
                console.log(`Navigate to details for ${budget.title}, URL: ${budget.url}`)
                // Potential navigation: 
                // if (pageName && URL_TO_PAGE_MAP[budget.url]) { 
                //   onNavigate(URL_TO_PAGE_MAP[budget.url]);
                // }
              }}
            >
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">
                  {budget.title}
                </CardTitle>
                <span className="text-2xl">{budget.icon}</span>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">${budget.spent.toLocaleString()}</div>
                <p className={`text-xs ${isOverspent ? 'text-red-500' : 'text-muted-foreground'}`}>
                  {isOverspent 
                    ? `$${Math.abs(remaining).toLocaleString()} overspent` 
                    : `$${remaining.toLocaleString()} remaining of $${budget.limit.toLocaleString()}`}
                </p>
                <Progress value={Math.min(percentageSpent, 100)} className="mt-4 h-2" />
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Keep the example link if needed, or remove */}
      {/* <button onClick={() => onNavigate('budgets-overview')} className="text-blue-500 hover:underline mt-6">
        Go to Budgets Overview Detail (Example)
      </button> */}
    </div>
  );
};

export default BudgetsPage; 